import { fetchData } from "../../utils/fetchData";
const userDetails = `/api/v1/user`;

const addUser = function (data) {
  return new Promise((resolve, reject) => {
    fetchData(userDetails, 'post', data)
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject({
          message: 'Unable to add user details at this moment.'
        });
      })
  })
}

const addAuthForSuperCeF = function (data) {
  return new Promise((resolve, reject) => {
    fetchData(userDetails+'/addAuth', 'post', data)
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject({
          message: 'Unable to add user details at this moment.'
        });
      })
  })
}

const removeAuthForSuperCeF = function (data) {
  return new Promise((resolve, reject) => {
    fetchData(userDetails+'/removeAuth', 'post', data)
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject({
          message: 'Unable to remove user mapping at this moment.'
        });
      })
  })
}

const getUsers = function () {
  return new Promise((resolve, reject) => {
    fetchData(userDetails, 'get')
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject({
          message: 'Unable to fetch users at this moment.'
        });
      })
  })
}


const deleteUser = function (id) {
  return new Promise((resolve, reject) => {
    fetchData(userDetails + `/${id}`, 'patch', {status: 0})
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject({
          message: 'Unable to delete user at this moment.'
        });
      })
  })
}

const restoreUser = function (id) {
  return new Promise((resolve, reject) => {
    fetchData(userDetails + `/${id}`, 'patch', {status: 1})
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject({
          message: 'Unable to restore user at this moment.'
        });
      })
  })
}

const updateUser = function (id, data) {
  return new Promise((resolve, reject) => {
    fetchData(userDetails + `/${id}`, 'put', data)
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject({
          message: 'Unable to update user data at this moment.'
        });
      })
  })
}

const checkLogin = () => {
  return new Promise((resolve, reject) => {
    fetchData('/check/login', 'get', {}, {}, { 'cache-control': 'no-cache' })
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject({
          message: 'Unable to check login at this moment.'
        });
      })
  })
}

const fetchRoles = () => {
  return new Promise((resolve, reject) => {
    fetchData(userDetails + '/roles', 'get')
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject({
          message: 'Unable to fetch roles at this moment.'
        });
      })
  })
}

export {
  addUser,
  deleteUser,
  updateUser,
  getUsers,
  restoreUser,
  removeAuthForSuperCeF,
  addAuthForSuperCeF,
  checkLogin,
  fetchRoles
};


// WEBPACK FOOTER //
// ./src/services/hrmsUser/hrmsUser.service.js